/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';
import { modalLinkClick } from '../../../analytics';

export default (set, get, feature, stackDimensions, name = 'stack builder') => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  const trackModalLinkClick = { feature, stackDimensions, name };

  draft.digitalData.modalLinkClick = trackModalLinkClick;

  modalLinkClick(trackModalLinkClick);
}), false, { type: 'TRACK_MODAL_LINK_CLICK' });
